import * as React from 'react';
import RoomoLogo from '@assets/img/img_roomo.svg';
import ImgNotFound from '@assets/img/img_not_found.svg';
import ImgImagePlaceholder from '@assets/img/img_picture_placeholder.svg';
export const AppImage = {
    RoomoLogo: () => React.createElement("img", { alt: 'Logo da Roomo', src: RoomoLogo, width: '80%' }),
    NotFound: () => React.createElement("img", { alt: 'N\u00E3o encontrado', src: ImgNotFound }),
    ImagePlaceholder: () => React.createElement("img", { alt: 'Imagem n\u00E3o encontrada', src: ImgImagePlaceholder }),
};
